import { createSelector } from 'reselect';
import { ApplicationState } from '../../reducers';
import { CurrentExportState } from '../../reducers/exporter/ExporterReducer';

const getExports = (state: ApplicationState) => state.exporter.exports;
const getDownloadReadyExports = (state: ApplicationState) => state.exporter.downloadReadyExports;

export const getRunningExports = createSelector([getExports], exports =>
  exports.filter(singleExport => singleExport.currentState === CurrentExportState.EXPORTING)
);

export const getReadyExports = createSelector([getDownloadReadyExports], downloadReadyExports =>
  downloadReadyExports.filter(exp => !exp.downloadState.started)
);

export const getExportsWithNotification = createSelector([getExports], exports =>
  exports.filter(singleExport => singleExport.showNotification)
);
